<template>
  <div class="project-card">
    <div class="project-card__avatar-wrapper">
      <router-link :to="{ name: 'hr-project-show', params: { id: projectData.id } }">
        <div class="project-card__avatar">
          <AvatarPlaceholder :name="projectData.name" />
        </div>
      </router-link>
    </div>

    <div class="project-card__data">
      <h2 class="project-card__title">
        <router-link :to="{ name: 'hr-project-show', params: { id: projectData.id } }">
          {{ projectData.name }}
        </router-link>
      </h2>
      <p class="project-card__client-name">
        {{ projectData.client_name }} - {{ clientName }}
        <span v-if="projectData.assigned_hr" class="project-card__hr-name">
          {{ hrName }}
        </span>
      </p>

      <div v-if="projectData.start_date" class="project-details">
        <div class="project-details__icon">
          <img src="@/assets/img/icon-project-details.svg" alt="Bench logo">
        </div>
        <div class="project-details__wrapper">
          <label class="project-details__label">Project term</label>
          <p class="project-details__data">
            {{ projectData.start_date | displayDate }} - {{ projectData.end_date | displayDate }}
          </p>
        </div>
      </div>

      <div v-if="projectData.team_size" class="project-details">
        <div class="project-details__icon">
          <img src="@/assets/img/icon-team-members.svg" alt="Bench logo">
        </div>
        <div class="project-details__wrapper">
          <label class="project-details__label">Team size</label>
          <p class="project-details__data">
            {{ teamSizeDisplay }} members
          </p>
        </div>
      </div>
    </div>

    <div class="project-card__statuses-wrapper">
      <div class="project-card__recruitment-status">
        <div class="project-card__status-label">Recruitment</div>
        <div :class="['project-card__status',
          `project-card__status--${projectData.highest_recruitment_status.toLowerCase()}`]"
        >
          {{ projectData.highest_recruitment_status }}
        </div>
      </div>

      <div class="project-card__project-status">
        <div class="project-card__status-label">Status</div>
        <div :class="['project-card__status',
          `project-card__status--${projectData.status.toLowerCase()}`]"
        >
          {{ projectData.status }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AvatarPlaceholder from '@/components/AvatarPlaceholder.vue';

export default {
  props: {
    projectData: {
      type: Object,
      required: true,
    },
  },

  components: {
    AvatarPlaceholder,
  },

  computed: {
    teamSizeDisplay() {
      let displaySize;
      switch (this.projectData.team_size) {
        case 'small':
          displaySize = '1-5';
          break;
        case 'medium':
          displaySize = '6-9';
          break;
        case 'large':
          displaySize = '10+';
          break;
        default:
          break;
      }
      return displaySize;
    },

    hrName() {
      return `(${this.projectData.assigned_hr.first_name}  ${this.projectData.assigned_hr.last_name})`;
    },

    clientName() {
      return `${this.projectData.client_first_name}  ${this.projectData.client_last_name}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.project-card {
  margin-bottom: 24px;
  padding: 16px 24px;
  background: #FFFFFF;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 3px 6px #00000029;

  @include tablet {
    flex-direction: row;
  }

  &__avatar-wrapper {
    text-align: center;
  }

  &__avatar {
    background: $color--secondary;
    width: 128px;
    height: 128px;
    border-radius: 4px;
    margin: 0 auto;
  }

  &__data {
    flex-grow: 1;
    margin: 16px 0;
    font-weight: 500;

    @include tablet {
      margin: 0 0 0 16px;
    }
  }

  &__title {
    color: $main--headers;
    font-size: 20px;
    line-height: 24px;
    a {
      color: $main--headers;
      text-decoration: unset !important;
    }
  }

  &__client-name {
    font-size: 14px;
    line-height: 16px;
    margin-bottom: 4px;
    color: $main--text;
    font-weight: 500;
  }

  &__hr-name {
    font-size: 14px;
    color: $color--gray;
  }

  &__statuses-wrapper {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: space-between;

    @include tablet {
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-end;
    }
  }

  &__status-label {
    font-size: 12px;
    line-height: 14px;
    text-align: right;
    margin-bottom: 4px;
  }

  &__status {
    font-size: 14px;
    background: $color--green;
    border-radius: 4px;
    color: #fff;
    padding: 8px 16px;
    text-transform: capitalize;

    &--ongoing {
      background: $color--yellow;
    }
    &--completed {
      background: $color--green;
    }
    &--closed {
      background: $color--red;
    }
    &--asap {
      background: $color--red;
    }
    &--urgent {
      background: $color--yellow;
    }
    &--basic {
      background: $color--green;
    }
  }
}

.project-details {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0px;
  }

  &__icon {
    margin-right: 8px;
    margin-top: 10px;
    display: flex;
    img {
      height: 22px;
    }
  }

  &__label {
    font-size: 10px;
    line-height: 12px;
    margin-bottom: 0;
  }
  &__data {
    font-size: 14px;
    font-weight: 500;
    line-height: 14px;
    margin-bottom: 0;
  }
}
</style>
